import React, { useState } from 'react';
import './ContactForm.css';
import getApiBase from "../utils/apiBase";
import Seo from '../components/Seo';
import { useI18n } from '../i18n/I18nContext';
import { trackAnalyticsEvent } from '../utils/analytics';

const API_BASE = getApiBase();

const ContactForm = () => {
  const { t } = useI18n();
  const [formState, setFormState] = useState({
    firstName: '',
    lastName: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    // 发送 POST 请求到 Flask 后端
    fetch(`${API_BASE}/api/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formState),
    })
    .then(response => {
      if (response.ok) trackAnalyticsEvent('contact_submit', { target: 'contact.submit' });
      return response.json();
    })
    .then(data => {
      console.log(data);
      // TODO: 处理响应，例如显示提交成功信息或清空表单

    })
    .catch((error) => {
      console.error('Error:', error);
      // TODO: 处理错误，例如显示提交失败信息
    });

    // 重置表单状态
    setFormState({
      firstName: '',
      lastName: '',
      email: '',
      subject: '',
      message: '',
    });
  };


  const handleChange = (e) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  return (
    <div className="contact-form-container">
      <Seo
        title={t('contact.seoTitle')}
        description={t('contact.seoDescription')}
        path="/contact"
      />
      <h1>{t('contact.title')}</h1>
      <p>{t('contact.intro')}</p>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="firstName">{t('contact.firstName')}</label>
          <input type="text" id="firstName" name="firstName" value={formState.firstName} onChange={handleChange} required />
        </div>
        <div>
          <label htmlFor="lastName">{t('contact.lastName')}</label>
          <input type="text" id="lastName" name="lastName" value={formState.lastName} onChange={handleChange} required />
        </div>
        <div>
          <label htmlFor="email">{t('contact.email')}</label>
          <input type="email" id="email" name="email" value={formState.email} onChange={handleChange} required />
        </div>
        <div>
          <label htmlFor="subject">{t('contact.subject')}</label>
          <input type="text" id="subject" name="subject" value={formState.subject} onChange={handleChange} required />
        </div>
        <div>
          <label htmlFor="message">{t('contact.message')}</label>
          <textarea id="message" name="message" className="message-box" value={formState.message} onChange={handleChange} required></textarea>
        </div>
        <button data-analytics-target="contact.submit" type="submit">{t('contact.submit')}</button>
      </form>
    </div>
  );
};

export default ContactForm;
